import { render, staticRenderFns } from "./ArabicAbout.vue?vue&type=template&id=554bbbc0&scoped=true"
import script from "./ArabicAbout.vue?vue&type=script&lang=js"
export * from "./ArabicAbout.vue?vue&type=script&lang=js"
import style0 from "./ArabicAbout.vue?vue&type=style&index=0&id=554bbbc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554bbbc0",
  null
  
)

export default component.exports